import { format } from "date-fns";

export function formatFecha(date: string | Date | null) {
    if (date) {
        let fecha: Date
        fecha = typeof date == 'string' ? new Date(date) : date;
        return format(fecha, 'dd/MM/yyyy');
    }
    return '-'
}